import { render, staticRenderFns } from "./qa-table.vue?vue&type=template&id=47da897b&scoped=true"
import script from "./qa-table.vue?vue&type=script&lang=js"
export * from "./qa-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47da897b",
  null
  
)

export default component.exports